import { format } from 'date-fns';
import { buildInputTableCols, ConversionQuantityFieldV2, DvtFieldV2 } from '@/components/custom/erp';
import { formatMoney, formatNumber } from '@/lib/formatUtils';

export const getDocumentsColumns = () =>
  buildInputTableCols([
    {
      field: 'ma_vt',
      headerName: 'Mã sản phẩm',
      width: 120,
      renderCell: params => params.row.ma_vt_data?.ma_vt
    },
    {
      field: 'ten_vt',
      headerName: 'Tên sản phẩm',
      width: 200,
      renderCell: params => params.row.ma_vt_data?.ten_vt
    },
    {
      field: 'dvt',
      headerName: 'Đơn vị tính',
      width: 100,
      renderCell: params => <DvtFieldV2 row={params.row} disabled={true} />
    },
    {
      field: 'so_luong0',
      headerName: 'Số lượng lấy',
      columnType: 'number',
      width: 100,
      renderCell: params => (
        <ConversionQuantityFieldV2 row={{ ...params.row, so_luong: params.row.so_luong0 }} disabled={true} />
      )
    },
    {
      field: 'so_luong',
      headerName: 'Số lượng',
      width: 100,
      columnType: 'number',
      renderCell: params => <ConversionQuantityFieldV2 row={params.row} disabled={true} />
    },
    {
      field: 'sl_cl',
      headerName: 'Sl còn lại',
      width: 100,
      columnType: 'number',
      renderCell: params => (
        <ConversionQuantityFieldV2 row={{ ...params.row, so_luong: params.row.sl_cl }} disabled={true} />
      )
    },
    {
      field: 'ma_kho',
      headerName: 'Mã kho',
      width: 120,
      renderCell: params => params.row.ma_kho_data?.ma_kho
    },
    {
      field: 'sl_ton',
      headerName: 'Tồn',
      width: 140,
      renderCell: params => formatMoney(params.row.sl_ton)
    },
    {
      field: 'ct_km',
      headerName: 'Loại hàng',
      width: 120,
      renderCell: params => (params.row.ct_km == '0' ? '0. Hàng bán' : '1. Hàng KM')
    },
    {
      field: 'gia_nt2',
      headerName: 'Giá bán VND',
      columnType: 'number',
      width: 170,
      renderCell: params => formatMoney(params.row.gia_nt2)
    },
    {
      field: 'tien_nt2',
      headerName: 'Doanh số VND',
      width: 170,
      columnType: 'number',
      renderCell: params => formatMoney(params.row.tien_nt2)
    },
    {
      field: 'tl_ck',
      headerName: 'Tỷ lệ ck (%)',
      width: 120,
      columnType: 'number',
      renderCell: params => formatMoney(params.row.tl_ck)
    },
    {
      field: 'ck_nt',
      headerName: 'Chiết khấu VND',
      columnType: 'number',
      width: 120,
      renderCell: params => formatMoney(params.row.ck_nt)
    },
    {
      field: 'ma_thue',
      headerName: 'Mã thuế',
      width: 120,
      renderCell: params => params.row.ma_thue_data?.ma_thue
    },
    {
      field: 'tk_thue_co',
      headerName: 'Tk thuế có',
      width: 120,
      renderCell: params => params.row.ma_thue_data?.tk_thue_dau_ra_data?.code
    },
    {
      field: 'thue_suat',
      headerName: 'Thuế suất (%)',
      columnType: 'number',
      width: 120,
      renderCell: params => params.row.ma_thue_data?.thue_suat
    },
    {
      field: 'thue_nt',
      headerName: 'Thuế VND',
      columnType: 'number',
      width: 120,
      renderCell: params => params.row.thue_nt
    },
    {
      field: 'tk_dt',
      headerName: 'TK doanh thu',
      width: 120,
      renderCell: params => params.row.ma_vt_data?.tk_dt_data?.code
    },
    {
      field: 'tk_gv',
      headerName: 'TK giá vốn',
      width: 120,
      renderCell: params => params.row.ma_vt_data?.tk_gv_data?.code
    },
    {
      field: 'tk_khcp',
      headerName: 'TK kho',
      width: 120,
      renderCell: params => params.row.ma_vt_data?.tk_khcp_data?.code
    },
    {
      field: 'tk_ck',
      headerName: 'TK chiết khấu',
      width: 120,
      renderCell: params => params.row.ma_vt_data?.tk_ck_data?.code
    },
    {
      field: 'tk_km',
      headerName: 'TK khuyến mãi',
      width: 120,
      renderCell: params => params.row.ma_vt_data?.tk_km_data?.code
    },
    {
      field: 'ngay_giao',
      headerName: 'Ngày giao',
      width: 120,
      renderCell: params => (params.row.ngay_giao ? format(params.row.ngay_giao, 'dd/MM/yyyy') : '')
    },
    {
      field: 'ma_bp',
      headerName: 'Bộ phận',
      width: 120,
      renderCell: params => params.row.ma_bp_data?.ma_bp
    },
    {
      field: 'ma_vv',
      headerName: 'Vụ việc',
      width: 120,
      renderCell: params => params.row.ma_vv_data?.ma_vv
    },
    {
      field: 'ma_hd',
      headerName: 'Hợp đồng',
      width: 120,
      renderCell: params => params.row.ma_hd_data?.ma_hd
    },
    {
      field: 'ma_dtt',
      headerName: 'Đợt thanh toán',
      width: 150,
      renderCell: params => params.row.ma_dtt_data?.ma_dtt
    },
    {
      field: 'ma_ku',
      headerName: 'Khế ước',
      width: 100,
      renderCell: params => params.row.ma_ku_data?.ma_ku
    },
    {
      field: 'ma_phi',
      headerName: 'Phí',
      width: 100,
      renderCell: params => params.row.ma_phi_data?.ma_phi
    },
    {
      field: 'ma_sp',
      headerName: 'Sản phẩm',
      width: 100,
      renderCell: params => params.row.ma_sp_data?.ma_vt
    },
    {
      field: 'ma_lsx',
      headerName: 'Lệnh sản xuất',
      width: 150,
      renderCell: params => params.row.ma_lsx_data?.ma_lsx
    },
    {
      field: 'ma_cp0',
      headerName: 'C/p không h/lệ',
      width: 150,
      renderCell: params => params.row.ma_cp0_data?.ma_cpkhl
    }
  ]);
